import styled from "styled-components"
import GridContainer from "@/components/common/GridContainer"
import { getCssSizeValue, getHtmlFromRedactorField, getPaddingsClassFromData } from "@/utils/utils"
import useSWR from "swr"
import { BREAKPOINTS } from "@/styles/themeSettings"
import SingleTile from "@/components/SocialMediaFeed/SingleTile"
import { ScrollTrigger } from "@/utils/gsap"

const Wrapper = styled.div`
	background: ${({ theme }) => theme.colors.platinum};
`

const Row = styled(GridContainer)`
	color: ${(props) => props.theme.colors.richBlack};

	&.first {
		margin-bottom: ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)};

		> div {
			border-top: 1px solid ${({ theme }) => theme.colors.slateGray};
			padding-top: ${getCssSizeValue(24)};
		}
	}

	&.second {
		margin-bottom: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};

		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			margin-bottom: ${getCssSizeValue(44, BREAKPOINTS.DESKTOP)};
		}
	}
`

const fetcher = (url) =>
	fetch(url).then((res) => {
		ScrollTrigger.refresh(true)
		return res.json()
	})

export const usePageFeed = () => {
	const { data, error } = useSWR("/api/getFacebookFeed", fetcher, {
		refreshInterval: 600000,
	})

	return {
		data,
		error,
		isLoading: !data && !error,
	}
}

export default function SocialMediaFeed({ data }) {
	const header = data?.header || ""
	const text = data?.text || ""
	const paddings = getPaddingsClassFromData(data)
	const { data: feed } = usePageFeed()
	const feedData = feed?.data || []

	return (
		<Wrapper className={paddings}>
			<Row className="first">
				<div className="col-desktop-8 col-mobile-8 typo-borna typo-borna-44">{header}</div>
			</Row>
			<Row className="second">
				<div
					className="col-desktop-6 col-mobile-8 typo-borna typo-borna-46"
					dangerouslySetInnerHTML={getHtmlFromRedactorField(text)}
				/>
			</Row>
			<Row>
				{feedData.map((item, index) => (
					<SingleTile key={item?.id || index} item={item} />
				))}
			</Row>
		</Wrapper>
	)
}
